<template>
<q-page class="main">
  <common-form :action="$route('flexible-rule.attach', {project_id: project.id})">
    <q-card class="page-card">
      <q-card-section class="page-card__main-content">
        <h1 class="heading-2 q-mb-lg">Flexibele richtlijnen
        </h1>
        <q-list bordered separator class="rounded-borders">
          <q-item v-for="rule in rules" :key="rule.id">
            <q-item-section>
              <template v-if="rule.versions.length && rule.versions[0].id !== rule.current_version.id">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="col-sm-6 col-md-3">
                    <q-checkbox :val="rule.versions[0].id"
                                name="rule_version_ids[]"
                                :label="rule.code"
                                v-model="attachedRules" />
                  </div>
                  <div class="col-sm-6 col-md-9">
                    <common-link :label="rule.current_version.summary"
                                 :href="$route('rule.show', {richtlijn: rule.id})" />
                    Gekoppeld aan
                    <a class="link link--primary"
                       :href="$route('rule.show_version', { rule_id: rule.id, version_id: rule.versions[0].id })">
                      versie {{ rule.versions[0].version }}
                    </a>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row items-center q-col-gutter-x-md">
                  <div class="col-sm-6 col-md-3">
                    <q-checkbox :val="rule.current_version.id"
                                name="rule_version_ids[]"
                                :label="rule.code"
                                v-model="attachedRules" />
                  </div>
                  <div class="col-sm-6 col-md-9">
                    <common-link :label="rule.current_version.summary"
                                 :href="$route('rule.show', {richtlijn: rule.id})" />
                  </div>
                </div>
              </template>
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
    <sticky-top-bar>
      <accent-button label="Opslaan" type="submit" />
    </sticky-top-bar>
    <sticky-bottom-bar>
      <template v-if="$isMobile">
        <common-fab icon="save" label="Opslaan"
                    type="submit" />
      </template>
    </sticky-bottom-bar>
  </common-form>

</q-page>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      attachedRules: [],
    }
  },
  mounted () {
    this.attachedRules = this.rules
        .filter(rule => rule.versions.length)
        .map(rule => rule.versions[0].id)
  },
}
</script>
